const Algo4Module = {
  namespaced: true,
  state: {
    questions: {
      question1: {
        value: "",
        question: "",
        span: "",
        clickedMoins: false,
        clickedPlus: false,
        disabled: false,
      },
      question2: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question3: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
      question4: {
        value: "",
        question: "",
        span: "",
        clickedYes: false,
        clickedNo: false,
        disabled: false,
      },
    },
    result: "",
  },
  getters: {
    getMyQuestions(state) {
      return state.questions;
    },
    getResult(state) {
      return state.result;
    },
    getClickedMoinsQuest1(state) {
      return state.questions.question1.clickedMoins;
    },
    getClickedPlusQuest1(state) {
      return state.questions.question1.clickedPlus;
    },
    getClickedYesQuest2(state) {
      return state.questions.question2.clickedYes;
    },
    getClickedNoQuest2(state) {
      return state.questions.question2.clickedNo;
    },
    getClickedYesQuest3(state) {
      return state.questions.question3.clickedYes;
    },
    getClickedNoQuest3(state) {
      return state.questions.question3.clickedNo;
    },
    getClickedYesQuest4(state) {
      return state.questions.question4.clickedYes;
    },
    getClickedNoQuest4(state) {
      return state.questions.question4.clickedNo;
    },
  },
  actions: {
    sendMoinsQuestion1({ commit }, value) {
      commit("SEND_MOINS_QUESTION1", value);
      commit("ANALYZE_QUESTION1");
    },
    sendPlusQuestion1({ commit }, value) {
      commit("SEND_PLUS_QUESTION1", value);
      commit("ANALYZE_QUESTION1");
    },
    sendYesQuestion2({ commit }, value) {
      commit("SEND_YES_QUESTION2", value);
      commit("ANALYZE_QUESTION2");
    },
    sendNoQuestion2({ commit }, value) {
      commit("SEND_NO_QUESTION2", value);
      commit("ANALYZE_QUESTION2");
    },
    sendYesQuestion3({ commit }, value) {
      commit("SEND_YES_QUESTION3", value);
      commit("ANALYZE_QUESTION3");
    },
    sendNoQuestion3({ commit }, value) {
      commit("SEND_NO_QUESTION3", value);
      commit("ANALYZE_QUESTION3");
    },
    sendYesQuestion4({ commit }, value) {
      commit("SEND_YES_QUESTION4", value);
      commit("ANALYZE_QUESTION4");
    },
    sendNoQuestion4({ commit }, value) {
      commit("SEND_NO_QUESTION4", value);
      commit("ANALYZE_QUESTION4");
    },
    clearState4({ commit }) {
      commit("CLEAR_STATE");
    },
  },
  mutations: {
    SEND_MOINS_QUESTION1(state, data) {
      if (state.questions.question1.value === "plus") {
        state.questions.question1.value = data;
        state.questions.question2.question = "";
        state.questions.question2.span = "";
        state.questions.question2.value = "";
        state.questions.question2.clickedYes = false;
        state.questions.question2.clickedNo = false;
        state.questions.question3.question = "";
        state.questions.question3.value = "";
        state.questions.question4.question = "";
        state.questions.question4.value = "";
        state.result = "";
        state.questions.question1.clickedMoins = true;
        state.questions.question1.clickedPlus = false;
        state.questions.question1.disabled = true;
      }
      state.questions.question1.value = data;
      state.questions.question1.clickedMoins = true;
      state.questions.question1.clickedPlus = false;
      state.questions.question1.disabled = true;
    },
    SEND_PLUS_QUESTION1(state, data) {
      if (state.questions.question1.value === "moins") {
        state.questions.question1.value = data;
        state.questions.question2.question = "";
        state.questions.question2.span = "";
        state.questions.question2.value = "";
        state.questions.question2.clickedYes = false;
        state.questions.question2.clickedNo = false;
        state.questions.question3.question = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.clickedNo = false;
        state.result = "";
        state.questions.question1.clickedPlus = true;
        state.questions.question1.clickedMoins = false;
        state.questions.question1.disabled = true;
      }
      state.questions.question1.value = data;
      state.questions.question1.clickedPlus = true;
      state.questions.question1.clickedMoins = false;
      state.questions.question1.disabled = true;
    },
    SEND_YES_QUESTION2(state, data) {
      if (state.questions.question2.value === "NO") {
        state.questions.question3.value = data;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = true;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = true;
        state.questions.question4.clickedNo = false;
        state.result = "";
        state.questions.question2.value = data;
        state.questions.question2.clickedYes = true;
        state.questions.question2.clickedNo = false;
        state.questions.question2.disabled = true;
      }
      state.questions.question2.value = data;
      state.questions.question2.clickedYes = true;
      state.questions.question2.clickedNo = false;
      state.questions.question2.disabled = true;
    },
    SEND_NO_QUESTION2(state, data) {
      if (state.questions.question2.value === "YES") {
        state.questions.question2.value = data;
        state.questions.question3.question = "";
        state.questions.question3.span = "";
        state.questions.question3.value = "";
        state.questions.question3.clickedYes = false;
        state.questions.question3.clickedNo = false;
        state.questions.question4.question = "";
        state.questions.question4.value = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.result = "";
        state.questions.question2.clickedNo = true;
        state.questions.question2.clickedYes = false;
        state.questions.question2.disabled = true;
      }
      state.questions.question2.value = data;
      state.questions.question2.clickedNo = true;
      state.questions.question2.clickedYes = false;
      state.questions.question2.disabled = true;
    },
    SEND_YES_QUESTION3(state, data) {
      if (state.questions.question3.value === "NO") {
        state.questions.question4.value = data;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.result = "";
      }
      state.questions.question3.value = data;
      state.questions.question3.clickedYes = true;
      state.questions.question3.clickedNo = false;
      state.questions.question3.disabled = true;
    },
    SEND_NO_QUESTION3(state, data) {
      if (state.questions.question3.value === "YES") {
        state.questions.question4.value = data;
        state.questions.question4.question = "";
        state.questions.question4.span = "";
        state.questions.question4.clickedYes = false;
        state.questions.question4.clickedNo = false;
        state.result = "";
      }
      state.questions.question3.value = data;
      state.questions.question3.clickedNo = true;
      state.questions.question3.clickedYes = false;
      state.questions.question3.disabled = true;
    },
    SEND_YES_QUESTION4(state, data) {
      state.questions.question4.value = data;
      state.questions.question4.clickedYes = true;
      state.questions.question4.clickedNo = false;
      state.questions.question4.disabled = true;
    },
    SEND_NO_QUESTION4(state, data) {
      state.questions.question4.value = data;
      state.questions.question4.clickedNo = true;
      state.questions.question4.clickedYes = false;
      state.questions.question4.disabled = true;
    },
    ANALYZE_QUESTION1(state) {
      if (state.questions.question1.value === "moins") {
        state.questions.question2.question =
          "La patiente a-t-elle des antécédents personnels?";
        state.questions.question2.span =
          "(Cancer sein / MTEV / Accident arteriel)";
      }
      if (state.questions.question1.value === "plus") {
        state.questions.question2.question =
          "La patiente a-t-elle des antécédents personnels?";
        state.questions.question2.span =
          "(Cancer sein / MTEV / Accident arteriel)";
      }
    },
    ANALYZE_QUESTION2(state) {
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "NO"
      ) {
        state.questions.question3.question =
          "La patiente a-t-elle des Interactions médicamenteuses?";
        state.questions.question3.span =
          "(prise de médicaments inducteurs enzymatiques)";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "NO"
      ) {
        state.questions.question3.question =
          "La patiente a-t-elle des Interactions médicamenteuses?";
        state.questions.question3.span =
          "(prise de médicaments inducteurs enzymatiques)";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
    },
    ANALYZE_QUESTION3(state) {
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO"
      ) {
        state.questions.question4.question =
          "La patiente souhaite-t-elle une contraception à longue durée d'action? ";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO"
      ) {
        state.questions.question4.question =
          "La patiente souhaite-t-elle une contraception à longue durée d'action? ";
      }
    },
    ANALYZE_QUESTION4(state) {
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO" &&
        state.questions.question4.value === "NO"
      ) {
        state.result = "NORLEVO Ellaone";
      }
      if (
        state.questions.question1.value === "moins" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO" &&
        state.questions.question4.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO" &&
        state.questions.question4.value === "YES"
      ) {
        state.result = "DIU CUIVRE";
      }
      if (
        state.questions.question1.value === "plus" &&
        state.questions.question2.value === "NO" &&
        state.questions.question3.value === "NO" &&
        state.questions.question4.value === "NO"
      ) {
        state.result = "Ellaone/DIU cuivre";
      }
    },
    CLEAR_STATE(state) {
      state.questions = {
        question1: {
          value: "",
          question: "",
          clickedMoins: false,
          clickedPlus: false,
          disabled: false,
        },
        question2: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question3: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
        question4: {
          value: "",
          question: "",
          clickedYes: false,
          clickedNo: false,
          disabled: false,
        },
      };
      state.result = "";
    },
  },
};

export default Algo4Module; // export the module
